export function setParamAll(paramFilterQueryLength, paramSelectedOptionsLength) {
  const allOptionsLength = Dashboards.getParameterValue(paramFilterQueryLength);
  const selectedOptionsLength = Dashboards.getParameterValue(paramSelectedOptionsLength).length;

  if (allOptionsLength == selectedOptionsLength) {
    Dashboards.fireChange('filterParamTipo', 'All');
  }
}